<template>
  <div>
    <el-form>
      <div class="row">
        <div class="col-4">
          <div class="card">
            <div class="card-body">
              <div class="card-title">
                <div class="row">
                  <div class="col-8">
                    <span style="font-size: var(--font-primary);">{{$t('İştirakçılar')}}</span>
                  </div>

                </div>
              </div>
              <div class="card-text">
                <el-form v-loading="loading">
                  <div class="row" v-for="item in participants" :key="item.id">
                    <div class="col-12">
                      <approval-part-card :item="item" />
                    </div>
                  </div>
                </el-form>
              </div>
            </div>
          </div>
        </div>
        <div class="col-4">
          <div class="card">
            <div class="card-body">
              <div class="card-title">
                <div class="row">
                  <div class="col-8">
                    <span style="font-size: var(--font-primary);">Sənədlər</span>
                  </div>

                </div>
              </div>
              <div class="card-text">
                <el-form v-loading="loading">
                  <div class="row" v-for="item in claimdocs" :key="item.id">
                    <div class="col-12">
                      <claim-docs-card :item="item" />
                    </div>
                  </div>
                </el-form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-form>

  </div>
</template>

<script>
import Upload from "../components/Upload.vue";
import ApprovalPartCard from "../components/ApprovalPartCard.vue";
import ClaimDocsCard from "../components/ClaimDocsCard.vue";
import {
  GetClaimDocs,
} from "../../services/claim";
import {
  GetParticipants,
} from "../../services/accident";
import ClaimDocs from "../components/ClaimDocs.vue";
// import Participant from "../components/Participant.vue";
// import ParticipantCard from "../components/ParticipantCard.vue";

export default {
  props: {
    accidentId: String,
    claimId: String,
  },
  components: {
    // Participant,
    // ParticipantCard,
    // ClaimDocs
    ApprovalPartCard,
    ClaimDocsCard
  },
  data() {
    return {
      loading: false,
      partloading: false,
      item: {},
      participants: [],
      uid: this.$store.state.user.id,
      claimdocs:[]
    };
  },
  methods: {
    getData() {
      this.loading = true;
      GetParticipants(this.accidentId).then((response) => {
        this.loading = false;
        if (response.data.data) {
          this.participants = response.data.data;
        } else {
          this.$message({
            type: "warning",
            message: "Səhv əməliyyat",
          });
        }
      });
    },
    getClaimDocs() {
      GetClaimDocs(this.claimId).then((response) => {
        if (response.data.data) {
          this.claimdocs = response.data.data;
        } else {
          this.$message({
            type: "warning",
            message: "Səhv əməliyyat",
          });
        }
      });
    },
  },

  mounted() {
    this.getData();
    this.getClaimDocs();
  },
};
</script>

<style lang="scss" scoped>

</style>